import { LOADING_END, LOADING_START } from "./actionTypes";

export const startLoading = () => ({
    type: LOADING_START,
});

export const endLoading = () => ({
    type: LOADING_END,
});
